module.exports = __webpack_public_path__ + "img/Jornay_OG_Image.db05c35e.jpg";